import { render, staticRenderFns } from "./SettingsNav.vue?vue&type=template&id=c03a2900&scoped=true"
import script from "./SettingsNav.vue?vue&type=script&lang=ts"
export * from "./SettingsNav.vue?vue&type=script&lang=ts"
import style0 from "./SettingsNav.vue?vue&type=style&index=0&id=c03a2900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03a2900",
  null
  
)

export default component.exports